<template>
   <div class="l-modal">
      <div class="loading-modal w-full px-4 md:px-0">
          <div class="loader bg-white w-full md:w-4/5 mx-auto rounded px-4 lg:px-8 lg:pb-6" v-on-clickaway="close">
            <div class="pt-6">
                <div class="flex justify-between">
                    <div>
                    <p class="text-sm mt-4 cursor-pointer font-bold text-lg">
                        Policy info
                    </p>
                    </div>
                    <font-awesome-icon icon="times-circle" class="cursor-pointer text-red-500 text-base lg:text-xl" @click="$emit('close')" />
                </div>
                <div class="mt-8">
                <p class="font-bold">Pet Type</p>
                <p v-if="policy.metadata.pet_type" class="mt-2 lg:mt-4 text-green-500 font-bold">{{policy.metadata.pet_type}}</p>
                <p v-else class="mt-2 lg:mt-4 text-green-500 font-bold">Null</p>
                </div>
                <p class="font-bold mt-6 underline">Pet Details</p>
                <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    <li>
                        <p>Breed Type</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BreedType}}</p>
                    </li>
                    <li>
                        <p>Breed Age</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BreedAge}}</p>
                    </li>
                    <li>
                        <p>Dog Id Number</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DogIdNumber}}</p>
                    </li>
                    <li>
                        <p>Acquisition Cost</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AcquisitionAmount}}</p>
                    </li>
                    <li>
                        <p>Maintenance Cost</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.MaintenanceCost}}</p>
                    </li>
                    <li>
                        <p>Medication Received</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.MedicationReceived}}</p>
                    </li>
                    <li>
                        <p>Pet Category</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.pet_category}}</p>
                    </li>
                </ul>
                    
                <p class="font-bold underline">KYC Info</p>
                <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" v-if="policy.metadata.pet_category != 'Individual'">
                    <li>
                        <p>DirectorName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorName}} </p>
                    </li>
                    <li>
                        <p>DirectorNationality</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorNationality}}</p>
                    </li>
                    <li>
                        <p>DirectorOccupation</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorOccupation}}</p>
                    </li>
                    <li>
                        <p>DirectorPhone</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorPhone}}</p>
                    </li>
                    <li>
                        <p>DirectorPosition</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorPosition}}</p>
                    </li>
                    <li>
                        <p>DirectorTitle</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorTitle}}</p>
                    </li>
                    <li>
                        <p>DirectorIdNumber</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorIdNumber}}</p>
                    </li>
                    <li>
                        <p>DirectorIdExpiryDate</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorIdExpiryDate}}</p>
                    </li>
                    <li>
                        <p>DirectorIdIssueDate</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorIdIssueDate}}</p>
                    </li>
                    <li>
                        <p>CompanyName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.CompanyName}}</p>
                    </li>

                    <li>
                        <p>AccountName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountName}}</p>
                    </li>
                    <li>
                        <p>AccountNumber</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountNumber}}</p>
                    </li>
                    <li>
                        <p>AccountType</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountType}}</p>
                    </li>
                    <li>
                        <p>BankBranch</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankBranch}}</p>
                    </li>
                    <li>
                        <p>BankName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankName}}</p>
                    </li>


                </ul>

               
                <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" v-else>
                    <li>
                        <p>Name</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.name}} </p>
                    </li>
                    <li>
                        <p>Email</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.email}}</p>
                    </li>
                    <li>
                        <p>Telephone</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.telephone}}</p>
                    </li>
                    <li>
                        <p>Address</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.user.address}}</p>
                    </li>
                    <li>
                        <p>Date Of Birth</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.dob}}</p>
                    </li>
                    <!-- <li>
                        <p>Nationality</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DirectorTitle}}</p>
                    </li> -->
                    <li>
                        <p>Occupation</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Occupation}}</p>
                    </li>
                    <li>
                        <p>Employer</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Employer}}</p>
                    </li>
                    <li>
                        <p>Employer Address</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.EmployerAddress}}</p>
                    </li>
                    <li>
                        <p>ID Type</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdType}}</p>
                    </li>

                    <li>
                        <p>ID Number</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountName}}</p>
                    </li>
                    <li>
                        <p>ID Issue Date</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdIssueDate}}</p>
                    </li>
                    <li>
                        <p>ID Expiry Date</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdExpiryDate}}</p>
                    </li>
                    <li>
                        <p>Tax ID Number</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.TaxID}}</p>
                    </li>
                    <li>
                        <p>AccountName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountName}}</p>
                    </li>
                    <li>
                        <p>AccountNumber</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountNumber}}</p>
                    </li>
                    <li>
                        <p>AccountType</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountType}}</p>
                    </li>
                    <li>
                        <p>BankBranch</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankBranch}}</p>
                    </li>
                    <li>
                        <p>BankName</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankName}}</p>
                    </li>


                    
                </ul>
                <hr class="mt-6"> 
                <a :href="policy.metadata.Signature" v-if="policy.metadata.Signature" target="_blank" rel="noopener noreferrer" class="mt-6 block text-green-500 underline">View Signature</a>
                <p v-else class="mt-6">Signature link not available</p>
                
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';
export default {
    props:['policy'],
    data(){
        return {
            existing: ''
        }
    },
    methods:{
        close(){
          this.$emit('close')
        // console.log('closeee')
        }
    },
    directives: {
        onClickaway: onClickaway,
    },
    mounted(){
        console.log(this.policy)
    }
}
</script>

<style scoped>
.loader{
  position: relative;
  top: 5px;
  max-width: 1000px
}
.img{
  width: 120px
}

</style>